/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// @ts-nocheck

import { ThemeProvider } from '@material-ui/styles'
import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { useHistory, useParams, useRouteMatch } from 'react-router-dom'

import { accountAction } from '../actions/auth.action'
import localStorageService from '../api/localStorageService'
import Loader from '../components/loader/Loader'
import Message from '../components/message/Message'
import RouterContext from '../contexts/route.context'
import { ROUTES } from '../helpers/constants'
import { selectMetaData, selectSchool } from '../helpers/selectors'
import { isEmpty, isUnauthRoute } from '../helpers/utils'

/**
 * Defines a component EditTemplate
 * @returns {*}
 * @constructor
 */
function withRouteContext(WrappedComponent) {
  function WrappedEnhanced({ accountAction, school, metadata }) {
    const params = useParams()
    const history = useHistory()
    const match = useRouteMatch()
    const [currentTheme, setCurrentTheme] = React.useState('')
    React.useEffect(() => {
      accountAction(
        params,
        () => {
          localStorageService.setDistrictSchool(params)
        },
        () => {
          localStorageService.clearDistrictSchool()
          history.push(ROUTES.NOTFOUNDROOT)
        }
      )
      // just for accessing school/district out of context places.
    }, [])
    React.useEffect(() => {
      if (isEmpty(metadata.school_theme)) {
        return
      }
      import(`./../assets/${metadata.school_theme}/theme`).then((theme) => {
        setCurrentTheme(theme)
      })
    }, [metadata.school_theme])
    if ((isUnauthRoute() && isEmpty(school)) || !currentTheme) {
      return <Loader />
    }
    return (
      <ThemeProvider theme={currentTheme.default}>
        <RouterContext.Provider value={{ params, match }}>
          <WrappedComponent />
          <Message />
        </RouterContext.Provider>
      </ThemeProvider>
    )
  }
  WrappedEnhanced.propTypes = {
    accountAction: PropTypes.func,
    school: PropTypes.object,
    metadata: PropTypes.object,
  }
  WrappedEnhanced.defaultProps = {
    accountAction: () => () => {},
    school: {},
    metadata: {},
  }

  const mapStateToProps = (state) => ({
    school: selectSchool(state),
    metadata: selectMetaData(state),
  })

  return connect(mapStateToProps, { accountAction })(WrappedEnhanced)
}

export default withRouteContext
